import {Button} from '@material-ui/core';
import {isNonEmptyString} from 'Core/models/EmptyString';
import React, {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {compose} from 'redux';
import {ReducerState} from 'rootReducer';
import Loading from 'Shared/components/Loading';
import RequiredTextInput from 'Shared/components/RequiredTextInput';
import {NoOp} from 'Shared/utilities/IOUtilities';
import {changeUsername, requestPasswordReset} from 'Users/ducks/passwordRecovery';
import './PasswordRecovery.sass';

const PasswordRecovery = () => {
  const {username} = useSelector((state: ReducerState) => state.user.passwordRecovery);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const onChangeUsername = compose(dispatch, changeUsername);
  const onRequestReset = isNonEmptyString(username)
    ? () => {
        dispatch(requestPasswordReset(username));
        setIsLoading(true);
      }
    : NoOp;

  return (
    <div className="password-recovery">
      <form className="password-recovery__form">
        {isLoading ? (
          <Loading />
        ) : (
          <>
            <h1>Password Recovery</h1>
            <p>Please enter the username of the account you want to recover below:</p>
            <RequiredTextInput
              className="password-recovery__input"
              onChange={onChangeUsername}
              label="Username"
              value={username}
            />
            <Button
              className="btn"
              type="submit"
              onClick={onRequestReset}
              disabled={!isNonEmptyString(username)}
              id="recover-password-button"
              color="primary"
              variant="contained"
            >
              Recover Password
            </Button>
          </>
        )}
      </form>
    </div>
  );
};

export default PasswordRecovery;
